import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import * as _ from "lodash";
import { ToastrService } from "ngx-toastr";
import { CostRegistrationRelations } from "../../../models/cost_registration_relations";
import { CostRegistrationsControllerService } from "../../../services/crossed-tables/cost-registrations-controller.service";
import { BaseError } from "../base-error";

@Component({
  selector: "app-cost-registrations",
  templateUrl: "./cost-registrations.component.html",
  providers: [CostRegistrationsControllerService],
})
export class CostRegistrationsComponent extends BaseError implements OnInit {
  public costRegistrationRelations: CostRegistrationRelations[][] = [];
  public serviceId: string;
  public selectedCostRegistrationRelations: CostRegistrationRelations;
  public rows = [];
  public columns = [];
  public headingsSwitched: boolean = false;
  public tableSwitched: boolean = false;

  constructor(private costRegistrationsControllerService: CostRegistrationsControllerService,
              private route: ActivatedRoute,
              toastr: ToastrService) {
    super(toastr);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
    });
    this.getDeterminantRegistrationRelations();
  }

  public getDeterminantRegistrationRelations() {
    this.costRegistrationsControllerService.getCostRegistrationsRelationsList(this.serviceId).subscribe(
      (data) => {
        this.costRegistrationRelations = data;
        if (this.tableSwitched) {
          this.tableSwitched = false;
          this.switchHeadings();
        }
      },
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
    );
  }

  public switchHeadings() {
    this.tableSwitched = !this.tableSwitched;
    const switchedEntries = [];
    if (this.costRegistrationRelations[0]) {
      for (let j = 0; j < this.costRegistrationRelations[0].length; j++) {
        const newRow = [];
        for (let i = 0; i < this.costRegistrationRelations.length; i++) {
          newRow.push(this.costRegistrationRelations[i][j]);
        }
        switchedEntries.push(newRow);
      }
    }
    this.costRegistrationRelations = switchedEntries;
  }

  public updateCostRegistration(costRegistrationRelations: CostRegistrationRelations) {
    this.costRegistrationsControllerService.saveCostRegistrations(this.serviceId, costRegistrationRelations).subscribe(
      (data) => {
        this.getDeterminantRegistrationRelations();
      },
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
    );
  }

  public editCostRegistrationEvent(costRegistrationRelations: CostRegistrationRelations) {
    if (costRegistrationRelations) {
      this.selectedCostRegistrationRelations = costRegistrationRelations;
      if (costRegistrationRelations.registrationHasCost) {
        this.selectedCostRegistrationRelations.registrationHasCost = false;
        this.updateCostRegistration(this.selectedCostRegistrationRelations);
      } else {
        costRegistrationRelations.registrationHasCost = true;
        this.updateCostRegistration(costRegistrationRelations);
      }
    }

  }

  public editCostRegistrationItem(costRegistrationRelations: CostRegistrationRelations) {
    if (costRegistrationRelations) {
      if (costRegistrationRelations.registrationHasCost) {
        costRegistrationRelations.registrationHasCost = false;
        // this.updateCostRegistration(costRegistrationRelations);
      } else {
        costRegistrationRelations.registrationHasCost = true;
        this.updateCostRegistration(costRegistrationRelations);
      }
    }
  }

}
